<nav
  class="sidebar"
  [ngClass]="{ sidebarPushRight: isActive, collapsed: collapsed }"
>
  <div class="list-group">
    <br />
    <br />
    <div class="nested-menu">
      <br />
      <br />
      <br />

      <div class="pruebas" *ngIf="esPruebas">ENTORNO DE PRUEBAS</div>

      <!--  HOME  -->
      <a
        class="navbar-brand"
        style="font-size: 13px; margin-left: 20px"
        [routerLink]="['home']"
        [routerLinkActive]="['router-link-active']"
      >
        <mat-icon>home</mat-icon> Inicio</a
      >
      <!-- INVENTARIO ==> ADMINISTRADOR -->
      <a
        class="list-group-item"
        (click)="addExpandClass('pages0')"
        *ngIf="tienePermiso('GESTION EQUIPOS')"
      >
        <span> <mat-icon>computer</mat-icon> Inventario </span> &nbsp;<i
          class="fa fa-caret-down"
        ></i>
      </a>
      <li class="nested" [class.expand]="showMenu === 'pages0'">
        <ul class="submenu">
          <!--OP 1: Alta de equipos-->
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('ALTA EQUIPO')"
          >
            <a class="nav-link" routerLink="altaequipo">Alta equipo</a>
          </li>
          <!--OP 2: Gestión de equipos-->
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('GESTION EQUIPOS')"
          >
            <!--*ngIf="tienePermiso('GESTION EQUIPOS')"-->
            <a class="nav-link" routerLink="gestionequipos"
              >Gestión de equipos</a
            >
          </li>
        </ul>
      </li>
      <!--  SOLICITUDES ==> SOLICITANTE DE RECURSOS HUMANOS -->
      <a
        class="list-group-item"
        (click)="addExpandClass('pages1')"
        *ngIf="tienePermiso('SOLICITAR EQUIPO')"
      >
        <span> <mat-icon>note_add</mat-icon> Solicitudes </span> &nbsp;<i
          class="fa fa-caret-down"
        ></i>
      </a>
      <li class="nested" [class.expand]="showMenu === 'pages1'">
        <ul class="submenu">
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('SOLICITAR EQUIPO')"
          >
            <a class="nav-link" routerLink="solicitudEquipo"
              >Realizar solicitud de equipo</a
            >
          </li>
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('VER TODAS LAS SOLICITUDES REALIZADAS')"
          >
            <a class="nav-link" routerLink="solicitudesDeEquipoSolicitante"
              >Ver solicitudes de equipo</a
            >
          </li>
        </ul>
      </li>
      <!--  ASIGNACION DIRECTA DE EQUIPOS ==> ADMINISTRADOR Y SOPORTE TÉCNICO -->
      <a
        class="list-group-item"
        (click)="addExpandClass('pages2')"
        *ngIf="tienePermiso('ASIGNAR EQUIPO SIN SOLICITUD')"
      >
        <span> <mat-icon>list</mat-icon> Asignación de equipo </span> &nbsp;<i
          class="fa fa-caret-down"
        ></i>
      </a>
      <li class="nested" [class.expand]="showMenu === 'pages2'">
        <ul class="submenu">
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('ASIGNAR EQUIPO SIN SOLICITUD')"
          >
            <a class="nav-link" routerLink="asignacionDirecta">
              Nueva asignación
            </a>
          </li>
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('REASIGNAR EQUIPOS DE EMPLEADO')"
          >
            <a class="nav-link" routerLink="reasignacionEquipo">
              Reasignaciones
            </a>
          </li>
        </ul>
      </li>
      <!--  ATENDER SOLICITUDES EQUIPO ==> SOPORTE TÉCNICO -->
      <a
        class="list-group-item"
        (click)="addExpandClass('pages3')"
        (click)="this.mostrarNumSolicitudesEquipo()"
        *ngIf="tienePermiso('GESTIONAR TODAS LAS SOLICITUDES')"
      >
        <span>
          <mat-icon>assignment_turned_in</mat-icon> Atender solicitudes de
          equipo
        </span>
        &nbsp;<i class="fa fa-caret-down"></i>
      </a>
      <li class="nested" [class.expand]="showMenu === 'pages3'">
        <ul class="submenu">
          <li class="nav-item" routerLinkActive="active">
            <a
              class="nav-link"
              routerLink="solicitudesDeEquipoAdministrador"
              (click)="this.mostrarNumSolicitudesEquipo()"
            >
              Solicitudes de equipo
              <mat-icon
                color="primary"
                matBadge="{{ this.numSoliEqui }}"
                matBadgeColor="warn"
                matBadgePosition="above after"
              >
                notifications</mat-icon
              >
            </a>
          </li>
        </ul>
      </li>
      <!-- SEGUIMIENTO ==> ADMINISTRADOR y SOPORTE TÉCNICO -->
      <a
        class="list-group-item"
        (click)="addExpandClass('pages5')"
        *ngIf="tienePermiso('CONTROL DE ASIGNACIONES')"
      >
        <span> <mat-icon>timeline</mat-icon> Seguimiento </span> &nbsp;<i
          class="fa fa-caret-down"
        ></i>
      </a>
      <li class="nested" [class.expand]="showMenu === 'pages5'">
        <ul class="submenu">
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('CONTROL DE ASIGNACIONES')"
          >
            <a class="nav-link" routerLink="seguimientoAsignacionEquipo">
              Asignación de equipos</a
            >
          </li>
        </ul>
      </li>
      <!-- MANTENIMEINTO ==> ADMINISTRADOR y SOPORTE TÉCNICO -->
      <a
        class="list-group-item"
        (click)="addExpandClass('pages6')"
        *ngIf="tienePermiso('CONTROL DE MANTENIMIENTOS')"
      >
        <span> <mat-icon>build</mat-icon> Mantenimiento </span> &nbsp;<i
          class="fa fa-caret-down"
        ></i>
      </a>
      <li class="nested" [class.expand]="showMenu === 'pages6'">
        <ul class="submenu">
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('AGENDAR MANTENIMIENTO')"
          >
            <a class="nav-link" routerLink="agendarMantenimiento">
              Agendar mantenimiento</a
            >
          </li>
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('CONTROL DE MANTENIMIENTOS')"
          >
            <a class="nav-link" routerLink="controlDeMantenimiento">
              Control de registros
            </a>
          </li>
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('REGISTRAR MANTENIMIENTO')"
          >
            <a class="nav-link" routerLink="registrarMantenimiento">
              Registrar mantenimiento
            </a>
          </li>
        </ul>
      </li>
      <!--=========================================================================================================================-->
      <!--  SOLICITUDES DE SERVICIOS ==> RECURSOS HUMANOS -->
      <a
        class="list-group-item"
        (click)="addExpandClass('pages7')"
        *ngIf="tienePermiso('SOLICITAR SERVICIOS')"
      >
        <span> <mat-icon>note_add</mat-icon> Solicitudes </span> &nbsp;<i
          class="fa fa-caret-down"
        ></i>
      </a>
      <li class="nested" [class.expand]="showMenu === 'pages7'">
        <ul class="submenu">
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('SOLICITAR SERVICIOS')"
          >
            <a class="nav-link" routerLink="solicitanteSolicitudes"
              >Realizar solicitud de servicios</a
            >
          </li>
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('VISUALIZAR SOLICITUDES')"
          >
            <a class="nav-link" routerLink="gestionSolicitudes">
              Ver solicitudes de servicios</a
            >
          </li>
        </ul>
      </li>
      <!-- CONTROL DE USUARIOS ==> ADMINISTRADOR -->
      <a
        class="list-group-item"
        (click)="addExpandClass('pages8')"
        *ngIf="tienePermiso('ADMINISTRAR USUARIOS')"
      >
        <span> <mat-icon>account_circle</mat-icon> Control de usuarios </span>
        &nbsp;<i class="fa fa-caret-down"></i>
      </a>
      <li class="nested" [class.expand]="showMenu === 'pages8'">
        <ul class="submenu">
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('ADMINISTRAR USUARIOS')"
          >
            <a class="nav-link" routerLink="AdministrarUsuarios"
              >Administrar usuarios</a
            >
          </li>
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('EXPEDIENTES')"
          >
            <a class="nav-link" routerLink="Expedientes"> Expedientes</a>
          </li>
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('UPDATE DATOS SOL')"
          >
            <a class="nav-link" routerLink="update"> Editar datos</a>
          </li>
        </ul>
      </li>
      <!--  ATENDER SOLICITUDES ==> ADMINISTRADOR -->
      <a
        class="list-group-item"
        (click)="addExpandClass('pages9')"
        *ngIf="tienePermiso('ATENDER SOLICITUDES')"
        (click)="this.mostrarNumSolicitudes()"
      >
        <span>
          <mat-icon>assignment_turned_in</mat-icon> Atender solicitudes de
          servicios
        </span>
        &nbsp;<i class="fa fa-caret-down"></i>
      </a>
      <li class="nested" [class.expand]="showMenu === 'pages9'">
        <ul class="submenu">
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('APROBAR SOLICITUD ALTA')"
          >
            <a
              class="nav-link"
              routerLink="gestionSolicitudesAdmin/ALTA DE SERVICIOS"
              (click)="this.mostrarNumSolicitudes()"
              >Alta de servicios
              <mat-icon
                color="primary"
                matBadge="{{ this.numSoliAlta }}"
                matBadgeColor="warn"
                matBadgePosition="above after"
              >
                notifications</mat-icon
              >
            </a>
          </li>
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('APROBAR SOLICITUD ACT')"
          >
            <a
              class="nav-link"
              routerLink="gestionSolicitudesAdmin2/ACTIVACIÓN DE PRIVILEGIOS"
              (click)="this.mostrarNumSolicitudes()"
            >
              Activación de privilegios
              <mat-icon
                color="primary"
                matBadge="{{ this.numSoliAct }}"
                matBadgeColor="warn"
                matBadgePosition="above after"
              >
                notifications</mat-icon
              >
            </a>
          </li>
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('APROBAR SOLICITUD SUSP')"
          >
            <a
              class="nav-link"
              routerLink="gestionSolicitudesAdmin3/SUSPENSIÓN DE SERVICIOS"
              (click)="this.mostrarNumSolicitudes()"
            >
              Suspensión de servicios
              <mat-icon
                color="primary"
                matBadge="{{ this.numSoliSusp }}"
                matBadgeColor="warn"
                matBadgePosition="above after"
              >
                notifications</mat-icon
              >
            </a>
          </li>
        </ul>
      </li>

      <!-- REPORTES -->
      <a class="list-group-item" (click)="addExpandClass('pages10')">
        <span> <mat-icon>assignment</mat-icon> Reportes </span> &nbsp;<i
          class="fa fa-caret-down"
        ></i>
      </a>
      <li class="nested" [class.expand]="showMenu === 'pages10'">
        <ul class="submenu">
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('REPORTE INVENTARIO EQUIPOS')"
          >
            <a class="nav-link" routerLink="reportes/reporte-inventario-equipos"
              >Reporte de inventario de equipos</a
            >
          </li>
        </ul>
      </li>

      <!-- SEGUIMIENTO ==> ADMINISTRADOR -->
      <a
        class="list-group-item"
        (click)="addExpandClass('pages11')"
        *ngIf="tienePermiso('SEGUIMIENTO')"
      >
        <span> <mat-icon>timeline</mat-icon> Seguimiento </span> &nbsp;<i
          class="fa fa-caret-down"
        ></i>
      </a>
      <li class="nested" [class.expand]="showMenu === 'pages11'">
        <ul class="submenu">
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('SEGUIMIENTO')"
          >
            <a class="nav-link" routerLink="SeguimientoControlU">
              Asignación de servicios</a
            >
          </li>
        </ul>
      </li>
      <!-- CONFIGURACION ==> ADMINISTRADOR -->
      <a
        class="list-group-item"
        (click)="addExpandClass('pages12')"
        *ngIf="tienePermiso('GESTION TIPOS SOLICITUD')"
      >
        <span> <mat-icon>settings</mat-icon> Configuración </span> &nbsp;<i
          class="fa fa-caret-down"
        ></i>
      </a>
      <li class="nested" [class.expand]="showMenu === 'pages12'">
        <ul class="submenu">
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('GESTION TIPOS SOLICITUD')"
          >
            <a class="nav-link" routerLink="GestionTipoSolicitud">
              Gestión de tipos de solicitud</a
            >
          </li>
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('GESTION TIPOS SERVICIOS')"
          >
            <a class="nav-link" routerLink="GestionTipoServicio">
              Gestión de servicios de T.I.</a
            >
          </li>
        </ul>
      </li>
      <!-- CONFIGURACION ==> SOPORTE TÉCNICO -->
      <a
        class="list-group-item"
        (click)="addExpandClass('pages13')"
        *ngIf="tienePermiso('GESTION TIPOS EQUIPOS')"
      >
        <span> <mat-icon>settings</mat-icon> Configuración </span> &nbsp;<i
          class="fa fa-caret-down"
        ></i>
      </a>
      <li class="nested" [class.expand]="showMenu === 'pages13'">
        <ul class="submenu">
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('GESTION TIPOS EQUIPOS')"
          >
            <a class="nav-link" routerLink="GestionTipoEquipo">
              Gestión de tipos de equipos</a
            >
          </li>

          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('GESTION MODELOS EQUIPOS')"
          >
            <a class="nav-link" routerLink="GestionModeloEquipo">
              Gestión de modelos de equipos</a
            >
          </li>
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('GESTION TIPOS MANT')"
          >
            <a class="nav-link" routerLink="GestionTipoMantenimiento">
              Gestión de tipos de mant.</a
            >
          </li>
          <li
            class="nav-item"
            routerLinkActive="active"
            *ngIf="tienePermiso('GESTION ACTIVIDADES MANT')"
          >
            <a class="nav-link" routerLink="GestionActividadMantenimiento">
              Gestión de actividades de mant.</a
            >
          </li>
        </ul>
      </li>
    </div>
  </div>
  <div
    class="toggle-button"
    [ngClass]="{ collapsed: collapsed }"
    (click)="toggleCollapsed()"
  >
    <i class="fa fa-fw fa-angle-double-left"></i>&nbsp;
    <span> Ocultar barra </span>
  </div>
</nav>
